import { Component, Input, OnInit } from '@angular/core';
import { MenuItem } from '../../model/menu-item';
import { AuthenticationService } from '../../service/authentication.service';
import { User } from '../../model/user';
import { Router } from '@angular/router';
import { NgRedux } from '@angular-redux/store';
import { ArgosState } from '../../../core/argos-state';
import { CLEAN_STATE } from '../../../core/actions';
import { HttpService } from '../../service/http.service';
import { HttpRequestBuilder } from '../../../core/http-request-builder';

@Component({
  selector: 'tx-nav-bar',
  templateUrl: './tx-nav-bar.component.html',
  styleUrls: ['./tx-nav-bar.component.css']
})
export class TxNavBarComponent implements OnInit {
  @Input() menuItems: Array<MenuItem>;
  user: User;

  isLoading: boolean;

  totalRequests = 0;

  constructor(private authenticationService: AuthenticationService,
              private router: Router,
              private ngRedux: NgRedux<ArgosState>,
              private httpService: HttpService,
              private httpRequestBuilder: HttpRequestBuilder) {
    this.user = this.authenticationService.getUserFromLocalStorage();
    this.setLoadingObserver();
  }

  ngOnInit() {
  }

  logout() {
    this.authenticationService.removeUser();
    this.router.navigate(['/login']);
    this.ngRedux.dispatch({ type: CLEAN_STATE });
  }

  setLoadingObserver() {
    this.httpService.isLoading$
      .subscribe(this.handleLoadingValue);

    this.httpRequestBuilder.isLoading$
      .subscribe(this.handleLoadingValue);
  }

  handleLoadingValue = (value) => {
    if (value) {
      this.totalRequests++;
      this.isLoading = true;
    } else {
      this.totalRequests--;
      if (this.totalRequests === 0) {
        this.isLoading = false;
      }
    }
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/component/tx-nav-bar/tx-nav-bar.component.ts